/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const PAGE_MODEL = {
    content: [],
    totalPages: 0,
    totalElements: 0,
    currentPage: 0
}